@if (isTranslationLoaded()) {
  <h1 class="h2 mb-4">{{ 'selfOnboarding.createAccount.title' | translate }}</h1>
  <fieldset aria-labelledby="existingCustomer" class="row g-2 mb-4">
    <legend id="existingCustomer">{{ 'selfOnboarding.createAccount.existingCustomer.question' | translate }}</legend>
    <span class="sr-only" id="existingCustomerInstructions">{{
      'selfOnboarding.createAccount.existingCustomer.instructions' | translate
    }}</span>
    <cfp-input-radio
      class="col-auto"
      [id]="'existingCustomerYes'"
      [ngModel]="isExistingCustomer()"
      (ngModelChange)="isExistingCustomer.set($event)"
      [radioValue]="true"
      [label]="'selfOnboarding.createAccount.existingCustomer.yes' | translate"
      [ariaDescribedby]="'existingCustomerInstructions'"
    />
    <cfp-input-radio
      class="col-auto"
      [id]="'existingCustomerNo'"
      [ngModel]="isExistingCustomer()"
      (ngModelChange)="isExistingCustomer.set($event)"
      [radioValue]="false"
      [label]="'selfOnboarding.createAccount.existingCustomer.no' | translate"
      [ariaDescribedby]="'existingCustomerInstructions'"
    />
  </fieldset>
  @if (isExistingCustomer() === true) {
    <p class="mb-4">{{ 'selfOnboarding.createAccount.requiredFields.note' | translate }}</p>
    <form [formGroup]="formGroup" #ngForm="ngForm" (submit)="continue()">
      <div class="row mb-4">
        <div class="col-12 col-lg-5">
          <cfp-form-group [label]="'selfOnboarding.createAccount.companyName' | translate">
            <span formGroupAfterLabel>*</span>
            <cfp-input-text
              formControlName="companyName"
              [autocomplete]="'organization'"
              [placeholder]="'selfOnboarding.createAccount.companyName.placeholder' | translate"
            />
            <cfp-validation-feedback [control]="formGroup.controls['companyName']" [showMessage]="ngForm.submitted" />
          </cfp-form-group>
          <cfp-form-group [label]="'selfOnboarding.createAccount.companyEmail' | translate">
            <span formGroupAfterLabel>*</span>
            <cfp-input-text
              formControlName="companyEmail"
              [autocomplete]="'email'"
              [placeholder]="'selfOnboarding.createAccount.companyEmail.placeholder' | translate"
            />
            <div class="mt-2">
              <cfp-icon [icon]="'circle-info'" [iconStyle]="'info'" [iconType]="'solid'" [classes]="'me-2'" />{{
                'selfOnboarding.createAccount.companyEmail.info' | translate
              }}
            </div>
            <cfp-validation-feedback [control]="formGroup.controls['companyEmail']" [showMessage]="ngForm.submitted" />
          </cfp-form-group>
          <cfp-form-group [label]="'selfOnboarding.createAccount.contactName' | translate">
            <span formGroupAfterLabel>*</span>
            <cfp-input-text
              formControlName="contactName"
              [placeholder]="'selfOnboarding.createAccount.contactName.placeholder' | translate"
              [autocomplete]="'name'"
            />
            <cfp-validation-feedback [control]="formGroup.controls['contactName']" [showMessage]="ngForm.submitted" />
          </cfp-form-group>
          @if (showAnnualRevenue()) {
            <cfp-form-group [label]="'selfOnboarding.createAccount.annualRevenue' | translate">
              <cfp-select formControlName="annualRevenue">
                @let annualRevenueParams =
                  { currencyCode: currencyCode(), currencySymbol: (currencyCode() | currencySymbol: 'narrow') };
                <cfp-option
                  [value]="'selfOnboarding.createAccount.annualRevenue.option1' | translate: annualRevenueParams"
                  [label]="'selfOnboarding.createAccount.annualRevenue.option1' | translate: annualRevenueParams"
                />
                <cfp-option
                  [value]="'selfOnboarding.createAccount.annualRevenue.option2' | translate: annualRevenueParams"
                  [label]="'selfOnboarding.createAccount.annualRevenue.option2' | translate: annualRevenueParams"
                />
                <cfp-option
                  [value]="'selfOnboarding.createAccount.annualRevenue.option3' | translate: annualRevenueParams"
                  [label]="'selfOnboarding.createAccount.annualRevenue.option3' | translate: annualRevenueParams"
                />
              </cfp-select>
            </cfp-form-group>
          }
          @if (showCountryOfIncorporation()) {
            <cfp-form-group [label]="'selfOnboarding.createAccount.countryOfIncorporation' | translate">
              <span formGroupAfterLabel>*</span>
              <cfp-select
                formControlName="countryOfIncorporation"
                [placeholder]="'selfOnboarding.createAccount.countryOfIncorporation.placeholder' | translate"
              >
                @for (countryCode of countries; track countryCode) {
                  <cfp-option [value]="countryCode" [label]="`countryCode.${countryCode}` | translate" />
                }
              </cfp-select>
              <cfp-validation-feedback
                [control]="formGroup.controls['countryOfIncorporation']"
                [showMessage]="ngForm.submitted"
              />
            </cfp-form-group>
          }
          @if (showSector()) {
            <cfp-form-group [label]="'selfOnboarding.createAccount.sector' | translate">
              <cfp-select
                formControlName="sector"
                [placeholder]="'selfOnboarding.createAccount.sector.placeholder' | translate"
              >
                @for (sector of sectors; track sector.value) {
                  <cfp-option [value]="sector.value" [label]="sector.label" />
                }
              </cfp-select>
            </cfp-form-group>
          }
          @if (showRelationManagerName()) {
            <cfp-form-group [label]="'selfOnboarding.createAccount.relationManagerName' | translate">
              @if (relationManagerNameRequired) {
                <span formGroupAfterLabel>*</span>
              }
              <cfp-input-text
                formControlName="relationManagerName"
                [placeholder]="'selfOnboarding.createAccount.relationManagerName.placeholder' | translate"
              />
              @if (relationManagerNameRequired) {
                <cfp-validation-feedback
                  [control]="formGroup.controls['relationManagerName']"
                  [showMessage]="ngForm.submitted"
                />
              }
            </cfp-form-group>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-5 align-items-center">
          <cfp-button [disabled]="isLoading()" [buttonOutline]="true" (clicked)="previous.emit()">{{
            'back.button' | translate
          }}</cfp-button>
          <cfp-button [disabled]="isLoading()" [type]="'submit'" [classes]="'ms-3'">{{
            'selfOnboarding.createAccount.buttons.continue' | translate
          }}</cfp-button>
        </div>
      </div>
    </form>
  } @else if (isExistingCustomer() === false) {
    <p class="mb-4">
      {{ 'selfOnboarding.createAccount.nonExistingCustomer.message' | translate }}
      @if (nonExistingCustomerExternalUrl) {
        <cfp-link [url]="nonExistingCustomerExternalUrl">{{
          'selfOnboarding.createAccount.nonExistingCustomer.link' | translate
        }}</cfp-link>
        {{ 'selfOnboarding.createAccount.nonExistingCustomer.messageSuffix' | translate }}
      }
    </p>

    <div class="row">
      <div class="col-12 col-lg-5">
        <cfp-button [disabled]="isLoading()" [buttonOutline]="true" (clicked)="previous.emit()">{{
          'back.button' | translate
        }}</cfp-button>
      </div>
    </div>
  }
}
